import { render } from "./PageFormDataPribadi.vue?vue&type=template&id=29853807"
import script from "./PageFormDataPribadi.vue?vue&type=script&lang=js"
export * from "./PageFormDataPribadi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__